export default __webpack_public_path__ + "static/media/shark.d11d2d61.jpg";